import React from "react";
import { Card, CardContent } from "@material-ui/core";
import { AccountCircle } from "@material-ui/icons";
import Grid from "@material-ui/core/Grid";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import IconButton from "@material-ui/core/IconButton";

import ArchiveIcon from "@material-ui/icons/Archive";
import AssignmentIcon from "@material-ui/icons/Assignment";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import { Link } from "react-admin";

function ListItemLink(props) {
  return <ListItem button component="a" {...props} />;
}

export class PesadorDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.styles = props.styles;
  }

  renderPesadorCard(user) {
    return (
      <Grid>
        <Grid container>
          <Grid item xs={12}>
            <h1>
              <AccountCircle /> {user.nombre} ({user.dni})
            </h1>
          </Grid>
        </Grid>
        <Grid container spacing={16}>
          <Grid item xs={12} md={4}>
            <Card>
              <CardContent>
                <h4>Ingreso de materiales</h4>
                <List component="nav">
                  <ListItemLink href="#/pesajes">
                    <ListItemIcon>
                      <ArchiveIcon />
                    </ListItemIcon>
                    <ListItemText primary="Puerta a puerta" />
                    <ListItemSecondaryAction>
                      <Link to="pesajes/create">
                        <IconButton edge="end" aria-label="Crear">
                          <AddCircleIcon />
                        </IconButton>
                      </Link>
                    </ListItemSecondaryAction>
                  </ListItemLink>
                  <ListItemLink href="#/ingreso-terceros">
                    <ListItemIcon>
                      <ArchiveIcon />
                    </ListItemIcon>
                    <ListItemText primary="Terceros" />
                    <ListItemSecondaryAction>
                      <Link to="ingreso-terceros/create">
                        <IconButton edge="end" aria-label="Crear">
                          <AddCircleIcon />
                        </IconButton>
                      </Link>
                    </ListItemSecondaryAction>
                  </ListItemLink>
                  <ListItemLink href="#/ingreso-grandes-generadores">
                    <ListItemIcon>
                      <ArchiveIcon />
                    </ListItemIcon>
                    <ListItemText primary="Grandes generadores" />
                    <ListItemSecondaryAction>
                      <Link to="ingreso-grandes-generadores/create">
                        <IconButton edge="end" aria-label="Crear">
                          <AddCircleIcon />
                        </IconButton>
                      </Link>
                    </ListItemSecondaryAction>
                  </ListItemLink>
                </List>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card>
              <CardContent>
                <h4>Producción</h4>
                <List component="nav">
                  <ListItemLink href="#/pesaje-material">
                    <ListItemIcon>
                      <AssignmentIcon />
                    </ListItemIcon>
                    <ListItemText primary="Pesaje de materiales" />
                    <ListItemSecondaryAction>
                      <Link to="pesaje-material/create">
                        <IconButton edge="end" aria-label="Crear">
                          <AddCircleIcon />
                        </IconButton>
                      </Link>
                    </ListItemSecondaryAction>
                  </ListItemLink>
                </List>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card>
              <CardContent>
                <h4>Salida de materiales</h4>
                <List component="nav">
                  <ListItemLink href="#/remitos">
                    <ListItemIcon>
                      <MonetizationOnIcon />
                    </ListItemIcon>
                    <ListItemText primary="Salidas" />
                    <ListItemSecondaryAction>
                      <Link to="remitos/create">
                        <IconButton edge="end" aria-label="Crear">
                          <AddCircleIcon />
                        </IconButton>
                      </Link>
                    </ListItemSecondaryAction>
                  </ListItemLink>
                </List>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    );
  }

  render() {
    const { user } = this.props;
    return this.renderPesadorCard(user);
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/Pesador.js